"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
require("./TransactionTableLoading.css");
var TransactionTableLoading = function (_a) {
    var headers = _a.headers;
    if (!headers || headers.length === 0) {
        return (react_1.default.createElement(core_1.TableRow, { className: "transaction-table-loading " },
            react_1.default.createElement(core_1.TableCell, { colSpan: 1 },
                react_1.default.createElement("span", { className: "flashy-loading-wrapper no-headers" }))));
    }
    else {
        return (react_1.default.createElement(core_1.TableRow, { className: "transaction-table-loading" }, headers.map(function (header, i) { return (react_1.default.createElement(core_1.TableCell, { key: i, colSpan: 1 },
            react_1.default.createElement("span", { className: "table-row-header" }, headers[i]),
            react_1.default.createElement("span", { className: "flashy-loading-wrapper" }))); })));
    }
};
exports.default = TransactionTableLoading;
